<template>
  <v-container fluid class="d-flex justify-center">
    <v-row justify="center">
      <v-col cols="12" align-self="center" class="d-flex justify-center py-0">
        <v-img :src="require('@/assets/shop-gem.png')" max-width="55px" />
      </v-col>
      <v-col cols="12" align-self="center" class="d-flex justify-center py-0">
        <span class="text-left vListSubtextColor--text font-size-xs">
          Gem Name
        </span>
      </v-col>
      <v-col cols="12" class="d-flex justify-center py-0">
        <span class="text-left success--text font-size-small"> 250$ </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ShopItem",
};
</script>

<style scoped></style>
